/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { DefaultDraggableListItemComponents } from '@/nestedRows';

import styles from '../styles/learningObjectivesListItemDragHandle.module.scss';

const LearningObjectivesListItemDragHandle = ({ isDragDisabled = false, item, provided }) => {
  const { hasChildren } = item;

  const { DragHandle } = DefaultDraggableListItemComponents;

  if (!hasChildren && !isDragDisabled) return <DragHandle item={item} provided={provided} />;

  return (
    <div
      className={styles.element}
      {...provided.dragHandleProps}
      aria-disabled="true"
      aria-hidden="true"
      data-testid={`learning-objectives-list-item-${item.id}-drag-handle-disabled`}
      tabIndex="-1"
    />
  );
};

LearningObjectivesListItemDragHandle.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
      ai_generated: PropTypes.bool,
      isDisplayed: PropTypes.bool,
    }),
  }).isRequired,
};

export default React.memo(LearningObjectivesListItemDragHandle);
